import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/retirement',
  component: () => import('../../routes/Retirement.svelte'),
  card: {
    id: 'retirement',
    title: 'Retirement Planner',
    description: 'Plan for a secure and comfortable retirement with our comprehensive projection tool.',
    icon: 'beach_access',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/retirement',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Retirement Calculator – Retirement Savings Calculator & Planner',
    description: 'Free retirement calculator to plan your retirement savings. Calculate how much you need to retire, check if you are on track, and estimate retirement age. Use our simple retirement calculator or advanced retirement calculator with Social Security projections. The best retirement calculator for retirement savings goals.',
  },
};

export default meta;
